import React from 'react';

const JurisdictionsDisclaimers = () => (
	<div className="container main">
		<h2>Avisos Legales</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>Canadá</h4>
				<p>
					Las alertas de retirada de productos de consumo en Canadá conciernen y resultan aplicables a los productos de consumo que la Ley canadiense sobre la seguridad de los productos de consumo
					(CCPSA, por sus siglas en inglés) define de la forma siguiente: «todo producto, así como sus componentes, piezas o accesorios, que ha sido previsiblemente adquirido por una persona para
					utilizarlo con fines no comerciales, principalmente para uso doméstico, recreativo o deportivo, incluidos su embalaje y/o envoltorio».
				</p>
				<p>
					También se incluyen los productos cosméticos. La Ley de Productos Alimenticios y Farmacéuticos canadiense
					define el término «cosmético» como «cualquier sustancia o mezcla de sustancias producidas, vendidas o representadas para su uso en la limpieza, mejora o alteración del cutis,
					la piel, el cabello o los dientes e incluyen los desodorantes y los perfumes».
				</p>
				<p>A continuación, se enumeran las categorías de productos a las que no resultan aplicables las alertas de retirada de productos de consumo canadienses:</p>
				<ul>
					<li>Explosivos con arreglo al artículo 2 de la Ley de explosivos.</li>
					<li>Dispositivos con arreglo al artículo 2 de la Ley de Productos Alimenticios y Farmacéuticos.</li>
					<li>Productos farmacéuticos con arreglo al artículo 2 de la Ley de Productos Alimenticios y Farmacéuticos.</li>
					<li>Productos antiparasitarios con arreglo al artículo 2, apartado 1 de la Ley sobre la fabricación, comercialización y uso de plaguicidas.</li>
					<li>Automóviles con arreglo al artículo 2 de la Ley sobre seguridad de los vehículos a motor y toda pieza que forme parte integrante de los mismos, que esté ensamblada o haya sido modificada antes de su venta al primer comprador, incluida cualquier otra pieza que la reemplace o modifique.</li>
					<li>Piensos con arreglo al artículo 2 de la Ley de piensos para animales.</li>
					<li>Fertilizantes y abonos con arreglo al artículo 2 de la Ley de productos fertilizantes.</li>
					<li>Buques y embarcaciones con arreglo al artículo 2 de la Ley de la Marina Mercante de Canadá de 2001 sobre transporte marítimo.</li>
					<li>Armas de fuego con arreglo al artículo 2 del Código Penal.</li>
					<li>Munición con arreglo al artículo 84, apartado 1 del Código Penal.</li>
					<li>Cargadores con arreglo al artículo 84, apartado 1 del Código Penal.</li>
					<li>Ballestas con arreglo al artículo 84, apartado 1 del Código Penal.</li>
					<li>Dispositivos prohibidos con arreglo al artículo 84, apartado 1, letras a) a d) sobre la definición de «dispositivo prohibido» del Código Penal.</li>
					<li>Plantas con arreglo al artículo 3 de la Ley de protección fitosanitaria, excepto las semillas de jequirití (abrus precatorius, más conocido como «regaliz americano»).</li>
					<li>Semillas con arreglo al artículo 2 de la Ley de semillas, excepto las semillas de jequirití (abrus precatorius, más conocido como «regaliz americano»).</li>
					<li>Sustancias controladas con arreglo al artículo 2, apartado 1 de la Ley de estupefacientes y sustancias controladas.</li>
					<li>Productos aeronáuticos con arreglo al artículo 3, apartado 1 de la Ley de aeronáutica.</li>
					<li>Animales con arreglo al artículo 2, apartado 1 de la Ley de sanidad animal.</li>
				</ul>
			</div>
		</div>
		<hr/>
		
		<div className="row">
			<div className="col-sm-12">
				<h4>Comisión Europea</h4>
				<p>Si no se especifica en la alerta del Safety Gate / RAPEX, el riesgo se refiere al riesgo para la salud y la seguridad de los consumidores.</p>
				<p>Desde 2010, las alertas también incluyen medidas adoptadas frente a productos no alimentarios para profesionales y productos no alimentarios que impliquen riesgos distintos, como, por ejemplo, riesgos para la seguridad o el medio ambiente.</p>
				<p>Desde 2019, las alertas que antes solo circulaban a título informativo entre las autoridades nacionales, también se publican en la página web cuando la autoridad nacional lo considere necesario.</p>
				<p>Las marcas, diseños y logotipos registrados que aparecen en este listado podrían haber sido utilizados por operadores económicos con infracción de los derechos de propiedad intelectual y, por consiguiente, sin el conocimiento o permiso del legítimo propietario.</p>
			</div>
		</div>
		<hr/>
		
		<div className="row">
			<div className="col-sm-12">
				<h4>Japón</h4>
				<p>Nuestras alertas de retirada conciernen y resultan aplicables a productos de consumo, tales como aparatos eléctricos y/o electrodomésticos, enseres domésticos, artículos de papelería y productos de entretenimiento, entre otros. Quedan excluidos del ámbito de aplicación de las alertas de retirada los productos alimentarios, automóviles y productos farmacéuticos (incluidos los cosméticos).</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>Estados Unidos</h4>
				<p>
					La Comisión estadounidense para la Seguridad de los Productos de Consumo es responsable de garantizar que una larga lista de productos de consumo, desde cafeteras a juguetes,
					pasando por cortadoras de césped y hasta fuegos artificiales o artículos pirotécnicos, no suponen riesgos para la salud y seguridad de los consumidores. No obstante, ciertas clases de productos de consumo recaen bajo el ámbito de competencia de otros organismos federales.
					Haga clic aquí para consultar la lista de productos sometidos al control de otros organismos federales:
					<a href="https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/" target="_blank">https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/</a>.
				</p>
			</div>
		</div>
		<hr/>
	</div>
);

export default JurisdictionsDisclaimers ;



// WEBPACK FOOTER //
// ./src/views/static/es/jurisdictions-disclaimers.js